// Build a WhatsApp-ready text message from a sale + its form snapshot, laid out
// in the order of the ClickUp "A-Team NEM Rakyat Submission" form. We only EXTRACT
// data already captured on the sale/snapshot — nothing is invented. Fields with no
// source are shown as a blank dash so the keyer fills them in ClickUp. File-upload
// fields are not included (they're attachments, not text).

const dash = (v) => {
    const s = v === 0 ? '0' : (v == null ? '' : String(v).trim());
    return s === '' ? '-' : s;
};

export function buildClickupExportMsg({ sale, formPayload, agentName, combinedAddress }) {
    const p = formPayload || {};
    const cust = sale?.customerDetails || {};

    const name = p.name || cust.customerName || '';
    const area = cust.city || p.city || '';
    const phone = p.phone || cust.phoneNumber || '';
    const email = p.email || cust.email || '';
    const address = combinedAddress || p.address || cust.address || '';

    // Battery: prefer the sale line item, fall back to the snapshot.
    const battLine = (sale?.lineItems || []).find(li => li.isBattery);
    const batteryKwh = battLine ? battLine.batteryKwh : (p.batteryKwh || 0);
    const batteryQty = battLine ? battLine.qty : (p.batteryQty || 0);

    const taskName = `${dash(name)} (${area || '-'}) - ${dash(agentName)}`;

    const lines = [
        '*A-Team NEM Rakyat Submission*',
        '━━━━━━━━━━━━━━━━━━━━',
        '',
        '*1. Task / Sales*',
        `Task Name: ${taskName}`,
        `Sales PIC: ${dash(agentName)}`,
        '',
        '*2. System*',
        `TNB Acc Number: ${dash(p.tnbAccountNo)}`,
        `Panel: ${p.panelWatt ? `${p.panelWatt}W` : '-'}`,
        `Panel Quantity: ${dash(sale?.panelQty)}`,
        `Inverter: ${p.kwac ? `${p.kwac} kW` : '-'}`,
        `kWac: ${dash(p.kwac)}`,
        '',
        '*3. Applicant*',
        `Applicant Full Name: ${dash(name)}`,
        `Applicant IC No.: ${dash(p.icNumber)}`,
        `Applicant Address: ${dash(address)}`,
        `Applicant Tel. No.: ${dash(phone)}`,
        `Applicant Email: ${dash(email)}`,
        '',
        '*4. Alternate Contact*',
        `Alternate Full Name: ${dash(p.emergencyName)}`,
        `Alternate Relationship: ${dash(p.emergencyRelationship)}`,
        `Alternate IC No.: ${dash(p.emergencyIc)}`,
        `Alternate Tel. No.: ${dash(p.emergencyPhone)}`,
        `Alternate Address: ${dash(p.emergencyAddress)}`,
        `Alternate Email: ${dash(p.emergencyEmail)}`,
        '',
        '*5. Battery*',
        `Battery: ${batteryKwh ? `${batteryKwh} kWh` : '-'}`,
        `Battery Quantity: ${batteryQty ? batteryQty : '-'}`,
        '',
        '*6. Site / Remarks*',
        'Site Condition: -',
        'Remarks for installation: -',
        '',
        '*7. Tax*',
        `Tax Identification Number (TIN): ${dash(p.tinNumber)}`,
    ];
    return lines.join('\n');
}
